import ConstantUtils from "../../../utils/ConstantUtils";
import { SoapUtils } from "../../../utils/SoapUtils";

export interface TimeSheetItem {
    userName?:              string;
    contactName?:           string;
    typeOfWorkColor?:       string;
    quantity?:              string;
    dimension3Name?:        string;
    dimension3?:            string;
    dimension2Name?:        string;
    dimension2?:            string;
    dimension1Name?:        string;
    dimension1?:            string;
    folderItem?:            string;
    projectItem?:           string;
    resultCost?:            string;
    hourlyCost?:            string;
    switchTotal?:           string;
    created?:               Date;
    createdBy?:             string;
    modified?:              Date;
    approved?:              string;
    approvedBy?:            Date;
    dateTo?:                Date;
    vat?:                   string;
    qty?:                   string;
    usedQuantity?:          string;
    resultPrice?:           string;
    isExpense?:             string;
    taskId?:                string;
    customId?:              string;
    nodeId?:                string;
    currency?:              string;
    currencyCost?:          string;
    rate?:                  string;
    status?:                string;
    comments?:              string;
    description?:           string;
    title?:                 string;
    typeOfWorkId?:          string;
    schedId?:               string;
    minutes?:               string;
    entryDate?:             Date;
    activityId?:            string;
    projectId?:             string;
    folderId?:              string;
    chargeable?:            string;
    entererId?:             string;
    resoId?:                string;
    userId?:                string;
    ident?:                 string;
    refId?:                 string;
    activityName?:          string;
    projectName?:           string;
    folderName?:            string;
    masterProjectId?:       string;
    masterFolderId?:        string;
    masterProjectName?:     string;
    masterFolderName?:      string;
    customerName?:          string;
    providerName?:          string;
    typeOfWorkName?:        string;
    entererName?:           string;
    entryTypeName?:         string;
    contractType?:          string;
    plannedTaskCurrent?:    string;
    invoiceId?:             string;
    invoiceNumber?:         string;
    itmVat?:                string;
    itmCurrency?:           string;
    itmVatValue?:           string;
    itmAmount?:             string;
    itmTotalAmount?:        string;
    itmTotalAmountWithVat?: string;
    wageType?:              string;
    wageTypeName?:          string;
    fixWageType?:           string;
    fixWageTypeName?:       string;
    userDimension1Name?:    string;
    userDimension1?:        string;
    userDimension2Name?:    string;
    userDimension2?:        string;
    userDimension3Name?:    string;
    userDimension3?:        string;
    contextDimension1Name?: string;
    contextDimension1?:     string;
    contextDimension2Name?: string;
    contextDimension2?:     string;
    contextDimension3Name?: string;
    contextDimension3?:     string;
}

export function toTimeSheetItemXML(item: TimeSheetItem): string{
    var parameters: string = '';

    parameters += SoapUtils.makeNode(item.userName, 'userName');
    parameters += SoapUtils.makeNode(item.contactName, 'contactName');
    parameters += SoapUtils.makeNode(item.typeOfWorkColor, 'typeOfWorkColor');
    parameters += SoapUtils.makeNode(item.quantity, 'quantity');
    parameters += SoapUtils.makeNode(item.dimension3Name, 'dimension3Name');
    parameters += SoapUtils.makeNode(item.dimension3, 'dimension3');
    parameters += SoapUtils.makeNode(item.dimension2Name, 'dimension2Name');
    parameters += SoapUtils.makeNode(item.dimension2, 'dimension2');
    parameters += SoapUtils.makeNode(item.dimension1Name, 'dimension1Name');
    parameters += SoapUtils.makeNode(item.dimension1, 'dimension1');
    parameters += SoapUtils.makeNode(item.folderItem, 'folderItem');
    parameters += SoapUtils.makeNode(item.projectItem, 'projectItem');
    parameters += SoapUtils.makeNode(item.resultCost, 'resultCost');
    parameters += SoapUtils.makeNode(item.hourlyCost, 'hourlyCost');
    if(item.created) parameters += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(item.created), 'created');
    parameters += SoapUtils.makeNode(item.createdBy, 'createdBy');
    if(item.modified) parameters += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(item.modified), 'modified');
    parameters += SoapUtils.makeNode(item.approved, 'approved');
    if(item.approvedBy) parameters += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(item.approvedBy), 'approvedBy');
    if(item.dateTo) parameters += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(item.dateTo), 'dateTo');
    parameters += SoapUtils.makeNode(item.vat, 'vat');
    parameters += SoapUtils.makeNode(item.qty, 'qty');
    parameters += SoapUtils.makeNode(item.usedQuantity, 'usedQuantity');
    parameters += SoapUtils.makeNode(item.resultPrice, 'resultPrice');
    parameters += SoapUtils.makeNode(item.isExpense, 'isExpense');
    parameters += SoapUtils.makeNode(item.taskId, 'taskId');
    parameters += SoapUtils.makeNode(item.customId, 'customId');
    parameters += SoapUtils.makeNode(item.nodeId, 'nodeId');
    parameters += SoapUtils.makeNode(item.currency, 'currency');
    parameters += SoapUtils.makeNode(item.currencyCost, 'currencyCost');
    parameters += SoapUtils.makeNode(item.rate, 'rate');
    parameters += SoapUtils.makeNode(item.status, 'status');
    parameters += SoapUtils.makeNode(item.comments, 'comments');
    parameters += SoapUtils.makeNode(item.description, 'description');
    parameters += SoapUtils.makeNode(item.title, 'title');
    parameters += SoapUtils.makeNode(item.typeOfWorkId, 'typeOfWorkId');
    parameters += SoapUtils.makeNode(item.schedId, 'schedId');
    parameters += SoapUtils.makeNode(item.minutes, 'minutes');
    if(item.entryDate) parameters += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(item.entryDate), 'entryDate');
    parameters += SoapUtils.makeNode(item.activityId, 'activityId');
    parameters += SoapUtils.makeNode(item.projectId, 'projectId');
    parameters += SoapUtils.makeNode(item.folderId, 'folderId');
    parameters += SoapUtils.makeNode(item.chargeable, 'chargeable');
    parameters += SoapUtils.makeNode(item.entererId, 'entererId');
    parameters += SoapUtils.makeNode(item.resoId, 'resoId');
    parameters += SoapUtils.makeNode(item.userId, 'userId');
    parameters += SoapUtils.makeNode(item.ident, 'ident');
    parameters += SoapUtils.makeNode(item.refId, 'refId');
    parameters += SoapUtils.makeNode(item.activityName, 'activityName');
    parameters += SoapUtils.makeNode(item.projectName, 'projectName');
    parameters += SoapUtils.makeNode(item.folderName, 'folderName');
    parameters += SoapUtils.makeNode(item.masterProjectId, 'masterProjectId');
    parameters += SoapUtils.makeNode(item.masterFolderId, 'masterFolderId');
    parameters += SoapUtils.makeNode(item.masterProjectName, 'masterProjectName');
    parameters += SoapUtils.makeNode(item.masterFolderName, 'masterFolderName');
    parameters += SoapUtils.makeNode(item.customerName, 'customerName');
    parameters += SoapUtils.makeNode(item.providerName, 'providerName');
    parameters += SoapUtils.makeNode(item.typeOfWorkName, 'typeOfWorkName');
    parameters += SoapUtils.makeNode(item.entererName, 'entererName');
    parameters += SoapUtils.makeNode(item.entryTypeName, 'entryTypeName');
    parameters += SoapUtils.makeNode(item.contractType, 'contractType');
    parameters += SoapUtils.makeNode(item.plannedTaskCurrent, 'plannedTaskCurrent');
    parameters += SoapUtils.makeNode(item.invoiceId, 'invoiceId');
    parameters += SoapUtils.makeNode(item.invoiceNumber, 'invoiceNumber');
    parameters += SoapUtils.makeNode(item.itmVat, 'itmVat');
    parameters += SoapUtils.makeNode(item.itmCurrency, 'itmCurrency');
    parameters += SoapUtils.makeNode(item.itmVatValue, 'itmVatValue');
    parameters += SoapUtils.makeNode(item.itmAmount, 'itmAmount');
    parameters += SoapUtils.makeNode(item.itmTotalAmount, 'itmTotalAmount');
    parameters += SoapUtils.makeNode(item.itmTotalAmountWithVat, 'itmTotalAmountWithVat');
    parameters += SoapUtils.makeNode(item.wageType, 'wageType');
    parameters += SoapUtils.makeNode(item.wageTypeName, 'wageTypeName');
    parameters += SoapUtils.makeNode(item.fixWageType, 'fixWageType');
    parameters += SoapUtils.makeNode(item.fixWageTypeName, 'fixWageTypeName');
    parameters += SoapUtils.makeNode(item.userDimension1Name, 'userDimension1Name');
    parameters += SoapUtils.makeNode(item.userDimension1, 'userDimension1');
    parameters += SoapUtils.makeNode(item.userDimension2Name, 'userDimension2Name');
    parameters += SoapUtils.makeNode(item.userDimension2, 'userDimension2');
    parameters += SoapUtils.makeNode(item.userDimension3Name, 'userDimension3Name');
    parameters += SoapUtils.makeNode(item.userDimension3, 'userDimension3');

    return parameters;
}